import { SORT_ORDER, TableColumn, TableConfig } from "../../../../../../@shared/models/table.models";

export const REVIEW_QNA_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "question",
        header: "Question",
        type: "custom",
        template: "questionTemplate",
        width: "20%",
        sortable: true
    },
    {
        field: "answer",
        header: "Answer",
        type: "custom",
        template: "answerTemplate",
        width: "25%"
    },
    {
        field: "author",
        header: "Author",
        type: "custom",
        template: "authorTemplate",
        width: "12%"
    },
    {
        field: "lastEdited",
        header: "Date",
        type: "custom",
        template: "dateTemplate",
        width: "13%"
    },
    {
        field: "document",
        header: "Document Name",
        type: "custom",
        template: "documentTemplate",
        width: "18%"
    },
    {
        field: "sourceType",
        header: "Source Type",
        type: "custom",
        template: "sourceTypeTemplate",
        width: "12%"
    }
];

export const REVIEW_QNA_TABLE_CONFIG: TableConfig = {
    selectable: true,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [10, 20, 30, 40],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No Q&A pairs found",
    globalFilter: false,
    responsive: true,
    columnSortingFunction: (field: string, order: SORT_ORDER) => { }
};
